// externals
import { useDispatch } from 'react-redux';

// libraries
import { Action } from '@interstate/components/Action';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as customerRiskAndCoverageActionCreators from '@makemydeal/dr-dash-store/actions/customerRiskAndCoverageActionCreators';

// components

export const CreditBureauLink = () => {
    const dispatch = useDispatch();
    return (
        <Action
            size="sm"
            data-testid="credit-bureau-link"
            sx={{ display: 'flex', justifyContent: 'start' }}
            onClick={() => {
                dispatch(baseDealActionCreators.setCustomerRiskAndCoverageTab('credit_bureau'));
                dispatch(baseDealActionCreators.setCustomerRiskAndCoverageSlideOutStatus(true));
                dispatch(customerRiskAndCoverageActionCreators.customerRiskAndCoverageSlideOutButton());
            }}
        >
            <span style={{ fontWeight: 500 }}>Credit Bureau Scores / Compliance Results</span>
        </Action>
    );
};
